<template>
  <div class="user-analysis-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>用户分析</span>
      </div>
      
      <!-- Date Range Picker -->
      <div class="filter-section">
        <el-select v-model="platform" placeholder="选择平台" @change="fetchData" style="width: 120px; margin-right: 10px;">
          <el-option label="全部平台" value=""></el-option>
          <el-option label="Steam" value="steam"></el-option>
          <el-option label="Android" value="android"></el-option>
          <el-option label="iOS" value="ios"></el-option>
          <el-option label="Editor" value="editor"></el-option>
        </el-select>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="fetchData"
          :clearable="false"
        >
        </el-date-picker>
        <el-button type="primary" @click="fetchData" style="margin-left: 10px;">查询</el-button>
      </div>

      <el-tabs v-model="activeTab">
        <!-- 每日活跃 & 新增 -->
        <el-tab-pane label="活跃与新增 (DAU / New)" name="summary">
          <el-table :data="summaryData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="date" label="日期" width="180"></el-table-column>
            <el-table-column prop="dau" label="活跃用户数 (DAU)"></el-table-column>
            <el-table-column prop="new_users" label="新增用户数"></el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- 在线时长 -->
        <el-tab-pane label="在线时长统计" name="duration">
          <el-table :data="durationData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="date" label="日期" width="180"></el-table-column>
            <el-table-column prop="userid" label="用户ID" width="220"></el-table-column>
            <el-table-column label="在线时长" width="180">
              <template slot-scope="scope">
                {{ formatDuration(scope.row.online_duration) }}
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- 场景分布记录 -->
        <el-tab-pane label="场景进度分布" name="scenes">
          <el-table :data="scenesData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="chapter" label="章节" width="220"></el-table-column>
            <el-table-column prop="scene" label="场景" width="220"></el-table-column>
            <el-table-column prop="user_count" label="停留用户数"></el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- API 对接说明 -->
        <el-tab-pane label="API 对接说明" name="api_docs">
          <div class="api-docs-content">
            <h3>客户端上报接口（无需鉴权）</h3>
            <p>这些接口主要供客户端游戏直接调用，只需提供 <code>userid</code>。</p>

            <el-card shadow="never" class="api-card">
              <div slot="header"><strong>1. 呼吸/心跳接口</strong></div>
              <p>用于记录用户的活跃状态，如果两次请求间隔不超过3分钟，服务端会自动累加当天的在线时长。</p>
              <ul>
                <li><strong>URL:</strong> <code>POST /api/stats/breath</code></li>
                <li><strong>Content-Type:</strong> <code>application/json</code></li>
                <li><strong>Body 示例:</strong> <pre><code>{
  "userid": "user_12345"
}</code></pre></li>
                <li><strong>Response:</strong> 成功返回纯文本 <code>OK</code></li>
              </ul>
            </el-card>

            <el-card shadow="never" class="api-card" style="margin-top: 20px;">
              <div slot="header"><strong>2. 场景变动接口</strong></div>
              <p>用于记录用户在何时到达了哪个章节和场景。</p>
              <ul>
                <li><strong>URL:</strong> <code>POST /api/stats/scene</code></li>
                <li><strong>Content-Type:</strong> <code>application/json</code></li>
                <li><strong>Body 示例:</strong> <pre><code>{
  "userid": "user_12345",
  "chapter": "chapter_1",
  "scene": "scene_5"
}</code></pre></li>
                <li><strong>Response:</strong> 成功返回纯文本 <code>OK</code></li>
              </ul>
            </el-card>

            <el-card shadow="never" class="api-card" style="margin-top: 20px;">
              <div slot="header"><strong>3. 修改用户昵称接口</strong></div>
              <p>用于客户端修改用户的昵称。</p>
              <ul>
                <li><strong>URL:</strong> <code>POST /api/stats/user/nickname</code></li>
                <li><strong>Content-Type:</strong> <code>application/json</code></li>
                <li><strong>Body 示例:</strong> <pre><code>{
  "userid": "user_12345",
  "nickname": "超级玩家",
  "platform": "steam" // 可选，默认为steam
}</code></pre></li>
                <li><strong>Response:</strong> 成功返回纯文本 <code>OK</code></li>
              </ul>
            </el-card>

            <el-card shadow="never" class="api-card" style="margin-top: 20px;">
              <div slot="header"><strong>4. 上传排行榜成绩接口</strong></div>
              <p>用于上传玩家在特定游戏中的通关时间。记录会保存所有数据，并在查询时按用时最短（升序）排名。</p>
              <ul>
                <li><strong>URL:</strong> <code>POST /api/stats/leaderboard/upload</code></li>
                <li><strong>Content-Type:</strong> <code>application/json</code></li>
                <li><strong>Body 示例:</strong> <pre><code>{
  "userid": "user_12345",
  "gameid": "mini_game_1",
  "duration": 120, // 整数（秒）
  "platform": "steam" // 可选
}</code></pre></li>
                <li><strong>Response:</strong> 成功返回纯文本 <code>OK</code></li>
              </ul>
            </el-card>

            <el-card shadow="never" class="api-card" style="margin-top: 20px;">
              <div slot="header"><strong>5. 获取排行榜接口</strong></div>
              <p>获取特定游戏的最快通关前 N 名，以及玩家自己的排名。按 duration 升序排列（时间越短名次越高）。</p>
              <ul>
                <li><strong>URL:</strong> <code>GET /api/stats/leaderboard?gameid=mini_game_1&userid=user_12345&platform=steam&num=100</code></li>
                <li><strong>Response 示例:</strong> <pre><code>{
  "list": [
    { "userid": "user_123", "nickname": "大佬", "duration": 45 }
  ],
  "my": {
    "rank": 42,
    "data": { "userid": "user_12345", "nickname": "超级玩家", "duration": 120 }
  }
}</code></pre></li>
              </ul>
            </el-card>
          </div>
        </el-tab-pane>
      </el-tabs>

    </el-card>
  </div>
</template>

<script>
import request from "@/net/request";

export default {
  name: "UserAnalysis",
  data() {
    // 默认查询最近7天
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
    
    const startStr = start.toISOString().split('T')[0];
    const endStr = end.toISOString().split('T')[0];

    return {
      dateRange: [startStr, endStr],
      platform: "",
      activeTab: "summary",
      loading: false,
      summaryData: [],
      durationData: [],
      scenesData: []
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    formatDuration(seconds) {
      if (!seconds) return '0秒';
      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = seconds % 60;
      let res = '';
      if (h > 0) res += h + '小时 ';
      if (m > 0) res += m + '分 ';
      res += s + '秒';
      return res;
    },
    async fetchData() {
      if (!this.dateRange || this.dateRange.length < 2) return;
      
      this.loading = true;
      const [start_date, end_date] = this.dateRange;
      
      try {
        // 请求摘要数据
        const summaryRes = await request.get("/stats/analysis/summary", {
          params: { start_date, end_date, platform: this.platform }
        });
        this.summaryData = summaryRes.data || [];

        // 请求时长数据
        const durationRes = await request.get("/stats/analysis/duration", {
          params: { start_date, end_date, platform: this.platform }
        });
        this.durationData = durationRes.data || [];

        // 请求场景数据
        const scenesRes = await request.get("/stats/analysis/scenes", {
          params: { start_date, end_date, platform: this.platform }
        });
        this.scenesData = scenesRes.data || [];
        
      } catch (error) {
        this.$message.error("获取统计数据失败: " + (error.response?.data?.message || error.message));
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.user-analysis-container {
  padding: 20px;
}
.filter-section {
  margin-bottom: 20px;
}
.api-docs-content {
  line-height: 1.6;
  color: #333;
}
.api-docs-content h3 {
  margin-top: 0;
}
.api-card pre {
  background-color: #f4f4f5;
  padding: 10px;
  border-radius: 4px;
  font-family: monospace;
}
</style>
